/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseEntityHistoryDataV1Dto } from './BaseEntityHistoryDataV1Dto';
export type BaseEntityHistoryJsonV1Dto = {
  /**
   * uuid
   */
  userId: string;
  /**
   * Name of the user
   */
  userName: string;
  /**
   * type of event
   */
  eventType: BaseEntityHistoryJsonV1Dto.eventType;
  /**
   * uuid
   */
  entityId?: string;
  /**
   * Type of the entity
   */
  readonly entityType: string;
  /**
   * type of action
   */
  action: BaseEntityHistoryJsonV1Dto.action;
  /**
   * the current version of the entity
   */
  entity?: Record<string, any>;
  /**
   * changes of the action
   */
  changes?: Array<BaseEntityHistoryDataV1Dto>;
};
export namespace BaseEntityHistoryJsonV1Dto {
  /**
   * type of event
   */
  export enum eventType {
    CHANGE_LOG = 'changeLog',
    PROCESS_TRANSITION = 'processTransition',
    TRIGGER_RUN = 'triggerRun',
  }
  /**
   * type of action
   */
  export enum action {
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
  }
}
